import WebsiteFooter from "common/layout/websiteFooter";
import { useState, useEffect } from "react";
import useGetArticles from "../hooks/useGetArticles";
import { toast } from "react-toastify";
import { BlogHeader } from "../components/BlogHeader";
import { TopArticles } from "../components/TopArticles";

import FeaturedArticles from "../components/featuredArticles";
import { ArticlesResponse } from "../../data/models/article";

export default function BlogPage() {
  const { data, isLoading, error, refetch } = useGetArticles();
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = data?.pages?.[0]?.meta?.pagination?.pageCount || 1;
  const totalArticles = data?.pages?.[0]?.meta?.pagination?.total || 0;

  const articlesAvailable =
    data?.pages && data.pages[0]?.data && data.pages[0].data.length >= 1;

  useEffect(() => {
    if (error) {
      toast.error(
        ({ closeToast }) => (
          <div className="flex items-center justify-between gap-2">
            <span>{error?.message ?? ""}</span>
            <span
              onClick={() => {
                refetch();
                closeToast();
              }}
              className="text-sm cursor-pointer text-black underline hover:text-gray-700"
            >
              Reload
            </span>
          </div>
        ),
        {
          autoClose: false,
          closeOnClick: false,
        },
      );
    }
  }, [error, refetch]);

  const handlePageClick = async (page?: number): Promise<ArticlesResponse> => {
    if (page) {
      setCurrentPage(page);
    }
    return refetch(page);
  };

  const reversedArticles = articlesAvailable
    ? data?.pages[0].data.reverse()
    : [];

  return (
    <>
      <BlogHeader />
      <FeaturedArticles articles={reversedArticles} />
      <TopArticles
        articles={reversedArticles}
        isLoading={isLoading}
        totalPages={totalPages}
        totalArticles={totalArticles}
        currentPageArticles={currentPage}
        refetch={handlePageClick}
      />
      <div className="mt-[100px] lg:mx-[10px]">
        <WebsiteFooter />
      </div>
    </>
  );
}
